import { authTemplateApiAxios } from "./../rest/AxiosWrapper";
import { BaseRestService } from "./BaseRestService";
import { PublicClientApplication } from '@azure/msal-browser';

export class TemplateRestService extends BaseRestService {
    constructor(secure: boolean, resource: string) {
        const axios = authTemplateApiAxios();
        super(axios, resource);
    }
}
